export const moduleConstantes = Object.freeze({
  MODULE_STUDEA_DRIVER_LICENCE: "MODULE_STUDEA_DRIVER_LICENCE",
  MODULE_STUDEA_REGISTRATION: "MODULE_STUDEA_REGISTRATION",
  MODULE_STUDEA_SKILL: "MODULE_STUDEA_SKILL",
  MODULE_STUDEA_DOCUMENT: "MODULE_STUDEA_DOCUMENT",
  MODULE_STUDEA_ABSENCE: "MODULE_STUDEA_ABSENCE",
  MODULE_STUDEA_GRADEBOOK: "MODULE_STUDEA_GRADEBOOK",
  MODULE_STUDEA_COURSE: "MODULE_STUDEA_COURSE",
  MODULE_STUDEA_NOTEPAD: "MODULE_STUDEA_NOTEPAD",
  MODULE_STUDEA_WEBLINKS: "MODULE_STUDEA_WEBLINKS",
  MODULE_STUDEA_MESSAGE: "MODULE_STUDEA_MESSAGE",
  MODULE_STUDEA_MISSIONS_ACTIVITIES: "MODULE_STUDEA_MISSIONS_ACTIVITIES",
  MODULE_STUDEA_QUESTIONNAIRE: "MODULE_STUDEA_QUESTIONNAIRE",
  MODULE_STUDEA_IA_COMPETENCES: "MODULE_STUDEA_IA_COMPETENCES",
  MODULE_STUDEA_PLACEMENT: "MODULE_STUDEA_PLACEMENT",
  MODULE_STUDEA_TRIAD_DECLARE_CONTRACT_RUPTURE: "MODULE_STUDEA_TRIAD_DECLARE_CONTRACT_RUPTURE",
  MODULE_STUDEA_GENERAL: "MODULE_STUDEA_GENERAL",
  MODULE_STUDEA_CONTROL: "MODULE_STUDEA_CONTROL",
  MODULE_STUDEA_NOTE: "MODULE_STUDEA_NOTE",
  MODULE_STUDEA_INVOICE: "MODULE_STUDEA_INVOICE",
  MODULE_STUDEA_SUIVI_PREVENTION_RUPTURE: "MODULE_STUDEA_SUIVI_PREVENTION_RUPTURE",
  MODULE_EMAILS: "MODULE_EMAILS",
  MODULE_YPAREO: "MODULE_YPAREO",
  MODULE_EDUSIGN: "MODULE_EDUSIGN",
  MODULE_AMMON: "MODULE_AMMON",
  MODULE_UNISERVICE: "MODULE_UNISERVICE",
});

export const unavailableModuleCodes = Object.freeze([
  moduleConstantes.MODULE_STUDEA_TRIAD_DECLARE_CONTRACT_RUPTURE,
  moduleConstantes.MODULE_STUDEA_REGISTRATION,
  moduleConstantes.MODULE_STUDEA_GENERAL,
  moduleConstantes.MODULE_STUDEA_QUESTIONNAIRE,
  moduleConstantes.MODULE_STUDEA_CONTROL,
  moduleConstantes.MODULE_EMAILS,
  moduleConstantes.MODULE_YPAREO,
  moduleConstantes.MODULE_EDUSIGN,
  moduleConstantes.MODULE_AMMON,
  moduleConstantes.MODULE_UNISERVICE,
  moduleConstantes.MODULE_STUDEA_NOTE,
  moduleConstantes.MODULE_STUDEA_INVOICE,
  moduleConstantes.MODULE_STUDEA_SUIVI_PREVENTION_RUPTURE,
  moduleConstantes.MODULE_STUDEA_MISSIONS_ACTIVITIES,
  moduleConstantes.MODULE_STUDEA_IA_COMPETENCES,
]);
